/**
 * Authenticated fetch: attaches Bearer token and redirects to login on session expiry.
 * Backend uses 401 with { error: 'Unauthorized' } or { error: 'Invalid token' }.
 */
const LOGIN_PATH = '/login'

function redirectToLogin() {
  localStorage.removeItem('token')
  const path = window.location.pathname || ''
  if (path === LOGIN_PATH || path.startsWith(`${LOGIN_PATH}/`)) {
    return
  }
  window.location.assign(LOGIN_PATH)
}

export async function authFetch(input, init = {}) {
  const token = localStorage.getItem('token')
  const headers = new Headers(init.headers || {})
  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }

  const res = await fetch(input, { ...init, headers })

  if (res.status === 401) {
    redirectToLogin()
    throw new Error('Unauthorized')
  }

  return res
}
